module.exports = __webpack_public_path__ + "static/5_left-88ab385cf77cb58538cea2ba1acc81f1.png";